import createIcon from '../../createIcon';

/**
 * @component @name Code
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS40IDE2LjZMNC44IDEyTDkuNCA3LjRMOCA2TDIgMTJMOCAxOEw5LjQgMTYuNlpNMTQuNiAxNi42TDE5LjIgMTJMMTQuNiA3LjRMMTYgNkwyMiAxMkwxNiAxOEwxNC42IDE2LjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Code = createIcon('Code', [
  [
    'path',
    {
      d: 'M9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6ZM14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6Z',
      key: 'xkdlmm',
    },
  ],
]);

export default Code;
